import { createSlice } from "@reduxjs/toolkit";
import {
  fetchOrganisationById,
  fetchOrganisations,
  updateOrganisation,
  updateStatusInOrg,
  fetchOrganizationDropdown,
} from "./thunk";

interface OrganisationState {
  organisationsList: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
  selectedOrganisation: any;
  orgDropDown: any[];
  industryTypeDropDown: any[];
  orgCityDropDown: any[];
  orgStateDropDown: any[];
  pincodeDropDown: any[];
  exportCSVLoading: boolean;
  exportCSVError: string | null;
  countryDropDown: any[]; // ✅ fixed
}

const initialState: OrganisationState = {
  organisationsList: [],
  rowCount: 0,
  loading: false,
  error: null,
  selectedOrganisation: null,
  orgDropDown: [],
  industryTypeDropDown: [],
  orgCityDropDown: [],
  orgStateDropDown: [],
  pincodeDropDown: [],
  countryDropDown: [], // ✅ now matches the corrected type
  exportCSVLoading: false,
  exportCSVError: null,
};


const organisationSlice = createSlice({
  name: "organisations",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Fetch All Organisations
      .addCase(fetchOrganisations.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganisations.fulfilled, (state, action) => {
        state.loading = false;
        state.organisationsList = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];
        state.rowCount =
          typeof action.payload.rowCount === "number"
            ? action.payload.rowCount
            : 0;
      })
      .addCase(fetchOrganisations.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch organisations";
      })

      // Fetch Single Organisation by ID
      .addCase(fetchOrganisationById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrganisationById.fulfilled, (state, action) => {
        state.loading = false;
        state.selectedOrganisation = action.payload;
      })
      .addCase(fetchOrganisationById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      })

      // Update Organisation
      .addCase(updateOrganisation.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.organisationsList = state.organisationsList.map((org) =>
          org.organization_id === action.payload.organization_id ? action.payload : org
        );
      })
      .addCase(updateOrganisation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to update organisation";
      })

      // Active organizations
      // Fetch Organization Dropdown
.addCase(fetchOrganizationDropdown.pending, (state) => {
  state.loading = true;
  state.error = null;
})
.addCase(fetchOrganizationDropdown.fulfilled, (state, action) => {
  state.loading = false;
  state.orgDropDown = Array.isArray(action.payload)
    ? action.payload
    : [];
})
.addCase(fetchOrganizationDropdown.rejected, (state, action) => {
  state.loading = false;
  state.error =
    typeof action.payload === "string"
      ? action.payload
      : action.error.message || "Failed to fetch organization dropdown";
})

      // Update Status
      .addCase(updateStatusInOrg.fulfilled, (state, action) => {
        if (!action.payload?.id) return;
        state.organisationsList = state.organisationsList.map((org) =>
          org.id === action.payload.id ? action.payload : org
        );
      })
      .addCase(updateStatusInOrg.rejected, (state, action) => {
        state.loading = false;
        state.error =
          action.error.message || "Failed to update organisation status";
      });
  },
});

export default organisationSlice.reducer;
